import React from 'react';
import { Box, Divider, IconButton, ListItemIcon, Menu, MenuItem, Stack, Typography } from '@mui/material';
import type { MenuProps } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowRight from 'assets/arrow-right-icon.svg?react';

import './CustomMenu.scss';

export interface CustomMenuRow {
  name: string;
  onClick: () => void;
  icon?: React.ReactElement;
}

interface IProps extends Pick<MenuProps, 'anchorEl' | 'sx'> {
  items: CustomMenuRow[];
  handleMenuClose: () => void;
  withDivider?: boolean;
  isArrowRight?: boolean;
  width?: string;
}

export const CustomMenu: React.FC<IProps> = ({ items, handleMenuClose, withDivider, anchorEl, isArrowRight, width = '390px' }) => {
  const itemClickHandler = (callback: () => void) => {
    handleMenuClose?.();
    callback?.();
  };

  return (
    <Menu
      anchorEl={anchorEl || undefined}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
      slotProps={{
        paper: {
          elevation: 0,
          sx: {
            overflow: 'visible',
            position: 'relative',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            padding: '40px 60px',
            borderRadius: '14px',
            width: `${width} !important`,
            maxWidth: 'calc(100vw - 32px)',
          },
        },
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <Box sx={{ position: 'absolute', right: '-50px', top: '-35px' }}>
        <IconButton onClick={handleMenuClose} size="large" aria-label="Menü schließen">
          <CloseIcon />
        </IconButton>
      </Box>
      {items.map(({ name, onClick, icon }, index) => (
        <MenuItem key={name} onClick={() => itemClickHandler(onClick)} className="psf-custom-menu__item">
          <Box className="psf-custom-menu__item-container">
            <div className="psf-custom-menu__item-children-container">
              <Stack direction="row" sx={{ gap: '10px' }}>
                {icon}
                <Typography variant="body2" sx={{ fontFamily: 'SparkasseWeb', fontSize: '16px', fontWeight: '700 !important', color: '#000000' }}>
                  {name}
                </Typography>
              </Stack>

              {isArrowRight && (
                <ListItemIcon>
                  <ArrowRight />
                </ListItemIcon>
              )}
            </div>
            {withDivider && items.length > 1 && index !== items.length - 1 && <Divider />}
          </Box>
        </MenuItem>
      ))}
    </Menu>
  );
};
